import { Col, Layout, Row } from 'antd'
import { Outlet } from 'react-router-dom'
import MainHeader from '../components/MainHeader'
import { Link } from 'react-router-dom'
import { LayoutFooter } from '../components/LayoutFooter'
import { useHasAccess } from '../../components/HasAccess'
import { Permission } from '../../utils/permissions'

const { Content } = Layout

export const BusinessLayout: React.FC = () => {
  const { hasAccess } = useHasAccess()

  const subItems = [
    {
      key: 'companies',
      label: <Link to={'/business/companies/list'}>Companies</Link>,
      hasAccess: hasAccess(Permission.manageBusiness),
    },
    {
      key: 'policies',
      label: <Link to={'/business/policies'}>Policies</Link>,
      hasAccess: hasAccess(Permission.manageBusiness),
    },
    {
      key: 'reservations',
      label: <Link to={'/business/reservations'}>Reservations</Link>,
      hasAccess: hasAccess(Permission.manageBusiness),
    },
  ]

  return (
    <Layout>
      <MainHeader subItems={subItems.filter((item) => item.hasAccess)} />
      <Layout style={{ minHeight: '100vh', marginTop: 128 }}>
        <Content>
          <Row className="container-row">
            <Col xs={24} className="px-4">
              <Outlet />
            </Col>
          </Row>
        </Content>
        <LayoutFooter />
      </Layout>
    </Layout>
  )
}
